export default "__VITE_ASSET__KareXu5l__"